import { render, staticRenderFns } from "./wizardBox.vue?vue&type=template&id=b16380fc&"
import script from "./wizardBox.vue?vue&type=script&lang=js&"
export * from "./wizardBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports